<template>
  <div class="product-info-page">
    <div class="banner-sec">
      <div class="banner banner-product">
        <div class="wd1">
          <h2 class="banner-title-main">产品服务</h2>
        </div>
      </div>
    </div>
    <div class="cp-one-2 cp-backcolor product-info-content">
      <div class="product-info-section">
        <h2 class="g-h3-title2">贷前多维度画像</h2>
        <ul class="cp-one-ul-col2 clearfix">
          <li class="fe-li">
            <img class="img_1" src="../assets/images/personal.png" alt="个人画像">
            <h3>个人画像</h3>
            <p>对用户身份信息和风险信息综合评估，快速甄别用户风险行为，为金融等机构提供全面的反欺诈保障。</p>
          </li>
          <li class="fe-li">
            <img class="img_1" src="../assets/images/enterprise.png" alt="企业画像">
            <h3>企业画像</h3>
            <p>为合作机构提供企业工商信息快速查询，对目标企业和法人的潜在风险进行提示，支持企业及关联企业信息变更的实时提示。</p>
          </li>
          <li class="fe-li">
            <img class="img_1" src="../assets/images/car.png" alt="车辆画像">
            <h3>车辆画像</h3>
            <p>为经营车辆相关业务的企业提供车辆信息核查和风险提示服务，可精准验证个人及企业车辆状态等信息。</p>
          </li>
        </ul>
      </div>
      <div class="product-info-section">
        <h2 class="g-h3-title2">贷后外呼服务</h2>
        <ul class="cp-one-ul-col2 clearfix">
          <li class="fe-li">
            <img class="img_2" src="../assets/images/xf1.png" alt="修复率">
            <h3>修复率</h3>
            <p>平均修复率可达85%</p>
          </li>
          <li class="fe-li">
            <img class="img_2" src="../assets/images/xf2.png" alt="接通率">
            <h3>接通率</h3>
            <p>接通率提升75%</p>
          </li>
          <li class="fe-li">
            <img class="img_2" src="../assets/images/xf3.png" alt="回款率">
            <h3>回款率</h3>
            <p>回款率提升超10%</p>
          </li>
        </ul>
      </div>

        <!--<ul v-if="personalActive == true" class="cp-one-ul-col2 clearfix" style="margin-top: 30px">
          <div class="inner clearfix" style="width: 60%">
            <li class="fe-li-inner">
              <div class="product-service-icon">
                <i class="fa fa-flag"></i>
              </div>
              <h3>身份核实</h3>
            </li>
            <li class="fe-li-inner">
              <div class="product-service-icon">
                <i class="fa fa-warning"></i>
              </div>
              <h3>风险提示</h3>
            </li>
            <li class="fe-li-inner">
              <div class="product-service-icon">
                <i class="fa fa-yen"></i>
              </div>
              <h3>交易信息</h3>
            </li>
            <li class="fe-li-inner">
              <div class="product-service-icon">
                <i class="fa fa-phone"></i>
              </div>
              <h3>运营商</h3>
            </li>
          </div>
        </ul>

        <ul v-if="enterpriseActive == true" class="cp-one-ul-col2 clearfix" style="margin-top: 30px">
          <div class="inner clearfix" style="width: 45%;margin: 0 auto">
            <li class="fe-li-inner">
              <div class="product-service-icon">
                <i class="fa fa-building"></i>
              </div>
              <h3>工商信息</h3>
            </li>
            <li class="fe-li-inner">
              <div class="product-service-icon">
                <i class="fa fa-warning"></i>
              </div>
              <h3>风险提示</h3>
            </li>
            <li class="fe-li-inner">
              <div class="product-service-icon">
                <i class="fa fa-yen"></i>
              </div>
              <h3>交易信息</h3>
            </li>
          </div>
        </ul>

        <ul v-if="carActive == true" class="cp-one-ul-col2 clearfix" style="margin-top: 30px">
          <div class="inner clearfix" style="width: 30%;float: right">
            <li class="fe-li-inner">
              <div class="product-service-icon">
                <i class="fa fa-car"></i>
              </div>
              <h3>车辆信息</h3>
            </li>
            <li class="fe-li-inner">
              <div class="product-service-icon">
                <i class="fa fa-warning"></i>
              </div>
              <h3>风险提示</h3>
            </li>
          </div>
        </ul>-->
      </div>
    </div>

</template>

<script>

  export default {
    name: 'Partner',
    data () {
      return {
        personalActive: false,
        enterpriseActive: false,
        carActive: false
      }
    },
    methods: {
      toPersonalActive() {
        let that = this;

        if(that.personalActive == true){
          that.personalActive = false;
        }else {
          that.personalActive = true;
          that.enterpriseActive = false;
          that.carActive = false;
        }
      },
      toEnterpriseActive() {
        let that = this;

        if(that.enterpriseActive == true){
          that.enterpriseActive = false;
        }else {
          that.personalActive = false;
          that.enterpriseActive = true;
          that.carActive = false;
        }
      },
      toCarActive() {
        let that = this;

        if(that.carActive == true){
          that.carActive = false;
        }else {
          that.personalActive = false;
          that.enterpriseActive = false;
          that.carActive = true;
        }
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/ProductInfo.vue